export type SavedThemePreference = 'dark' | 'light' | null

export function readSavedThemePreference(): SavedThemePreference {
  if (typeof localStorage === 'undefined') return null
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme === 'dark' || savedTheme === 'light') return savedTheme
  return null
}

export function resolveThemeShouldBeDark(preference: SavedThemePreference = readSavedThemePreference()): boolean {
  if (preference === 'dark') return true
  if (preference === 'light') return false
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

/** Keep `html.dark` aligned with localStorage / system preference. Returns true when class was corrected. */
export function syncDocumentThemeFromStorage(): boolean {
  if (typeof document === 'undefined') return false

  const preference = readSavedThemePreference()
  const shouldBeDark = resolveThemeShouldBeDark(preference)
  const hasDark = document.documentElement.classList.contains('dark')

  if (shouldBeDark === hasDark) return false

  document.documentElement.classList.toggle('dark', shouldBeDark)

  if (preference === null && typeof localStorage !== 'undefined') {
    localStorage.setItem('theme', shouldBeDark ? 'dark' : 'light')
  }

  return true
}
